import React from 'react';
import { createMergingContextProvider } from './helpers';

// TODO browsev2_thumbs clean up deprecated when merging
export interface OverlayContextProps {
  /** enable/disable the overlay as a whole */
  showOverlay?: boolean;

  /** show the fave button and stat */
  showFaveControl?: boolean;
  /** show the comment button and stat */
  showCommentControl?: boolean;
  /** @deprecated */
  iconType?: 'outline' | 'filled';
  /** @deprecated */
  showPermanentEngagementIcon?: boolean;
  /** show the unhovered faved indicator */
  showFaveEngagementIcon?: boolean;
  /** show the unhovered commented indicator */
  showCommentEngagementIcon?: boolean;
  /** show stats on the fave/comment buttons */
  showStats?: boolean;
  /** show the author name and avatar */
  showAuthor?: boolean;
  /** show the owner (purchased deviation) name and avatar */
  showOwner?: boolean;
  /** show the author name */
  showAuthorName?: boolean;
  /** show the owner name */
  showOwnerName?: boolean;
  /** show the author user hover card */
  showAuthorTooltip?: boolean;
  /** show the author user hover card */
  showOwnerTooltip?: boolean;
  /** show the watch button for the author */
  showAuthorWatchButton?: boolean;
  /** show the watch button for the owner */
  showOwnerWatchButton?: boolean;
  /** show the title (can be overridden by certain deviation types) */
  showTitle?: boolean;
  /** show the paywall for PG content */
  showPremiumFolderOverlay?: boolean;
  /** show the icon indicator for PG content
   * @deprecated
   */
  showPremiumFolderIcon?: boolean;
  /** show the paywall for sub content */
  showSubscriberOverlay?: boolean;
  /** @deprecated */
  showSubscriberIcon?: boolean;
  /** @deprecated */
  showSuggestedReasonLabel?: boolean;
  /** show the DD flag */
  showDailyDeviationLabel?: boolean;
  /** show the Hype flag */
  showHypeLabel?: boolean;
  /** show the Stash flag */
  showStashLabel?: boolean;
  /** show the dropdown menu */
  showExtraActions?: boolean;
  /** @deprecated */
  isSwiperMode?: boolean;
  /** show sub/pg/pcp/etc indicators */
  showThumbStatusIndicators?: boolean;
  /** show gif/video indicators */
  showMediaIndicators?: boolean;
  /** show mlt (more like this) button */
  showMlt?: boolean;
  /** show "award badge" button */
  showAwardBadge?: boolean;
  /** show "boosted" indication */
  showBoosted?: boolean;
  /** show the overlay always in hovered state
   * USING THIS OUTSIDE OF STORIES WILL RESULT IN RUDE WORDS
   */
  __forceHoveredForStories?: boolean;
}

export const overlayContextDefaults: OverlayContextProps = {
  showOverlay: true,
  showFaveControl: true,
  showCommentControl: true,
  showAuthor: true,
  showOwner: true,
  showPremiumFolderOverlay: true,
  showPremiumFolderIcon: true,
  showSubscriberOverlay: true,
  showSubscriberIcon: true,
  showSuggestedReasonLabel: true,
  showDailyDeviationLabel: true,
  showHypeLabel: true,
  showStashLabel: false,
  showTitle: true,
  showStats: true,
  showAuthorName: true,
  showOwnerName: true,
  showExtraActions: true,
  showThumbStatusIndicators: true,
  showMediaIndicators: true,
  showMlt: true,
  showAwardBadge: true,
  showBoosted: true,
  showAuthorWatchButton: true,
  showOwnerWatchButton: true,
};

export const OverlayContext = React.createContext<OverlayContextProps>(
  overlayContextDefaults
);
OverlayContext.displayName = 'OverlayContext';

export const OverlayContextProvider =
  createMergingContextProvider(OverlayContext);
